import { DateTime, Duration } from 'luxon'
import { Service, service } from './di'

@service
export class DateTimeService extends Service {
    getNow(): DateTime {
        return DateTime.local()
    }

    fromJsDate(jsDate: Date, zone = 'utc'): DateTime {
        return DateTime.fromJSDate(jsDate, { zone })
    }

    formatDate(date: Date, formatStr: string, locale: string = 'en'): string {
        return DateTime.fromJSDate(date, { zone: 'utc', locale }).toFormat(
            formatStr
        )
    }

    setLocale(locale: any): DateTime {
        return DateTime.local().setLocale(locale)
    }

    getDuration(firstDate: DateTime, lastDate: DateTime): Duration {
        return firstDate.diff(lastDate)
    }

    getExactDuration(durationObj: any, unit: any): Duration {
        return durationObj.as(unit)
    }

    convertTimeToZulu(dateStr?: string, endOfDay = false): Date {
        if (!dateStr) return new Date()

        const dateStrShort = dateStr && dateStr.split('T') // "2021-06-20T23:59:59-04:00"
        const shortDate = dateStrShort[0]
        const ymd = shortDate.split('-')
        const year = Number(ymd[0])
        const month = Number(ymd[1]) - 1
        const day = Number(ymd[2])
        const hours = endOfDay ? 23 : 0
        const minutes = endOfDay ? 59 : 0
        const seconds = endOfDay ? 59 : 0
        return new Date(Date.UTC(year, month, day, hours, minutes, seconds))
    }
}
